import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../assets/close.svg'
import _imports_1 from './../assets/ask_question.svg'


const _withScopeId = n => (_pushScopeId("data-v-3fcd53ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Connect To Robot", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "icon-button",
  title: "Exit nodes canvas"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_6 = { class: "body-div" }
const _hoisted_7 = { class: "step-container flex-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-circle step-1" }, "Step 1", -1))
const _hoisted_9 = { class: "input-div" }
const _hoisted_10 = { class: "flex-row" }
const _hoisted_11 = { class: "flex-row" }
const _hoisted_12 = { class: "step-container flex-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-circle step-2" }, "Step 2", -1))
const _hoisted_14 = { class: "input-div" }
const _hoisted_15 = { class: "flex-row" }
const _hoisted_16 = { class: "flex-row" }
const _hoisted_17 = { class: "step-container flex-row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-circle step-3" }, "Step 3", -1))
const _hoisted_19 = { class: "input-div" }
const _hoisted_20 = { class: "flex-row" }
const _hoisted_21 = { class: "input-div" }
const _hoisted_22 = { class: "flex-row connect-prompt-text" }
const _hoisted_23 = { class: "button-div" }
const _hoisted_24 = {
  key: 0,
  class: "error-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchableDropDown = _resolveComponent("SearchableDropDown")!
  const _component_LoadPackagesPopup = _resolveComponent("LoadPackagesPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "icon-button",
        title: "Exit nodes canvas",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onExit()))
      }, _hoisted_3),
      _hoisted_4,
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createTextVNode(" Please Enter the IP address and port of your robot. "),
          _createElementVNode("b", _hoisted_10, [
            _createTextVNode("IP/Hostname: "),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input-box",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.hostname) = $event)),
              spellcheck: "false"
            }, null, 512), [
              [_vModelText, _ctx.hostname]
            ])
          ]),
          _createElementVNode("b", _hoisted_11, [
            _createTextVNode("Port: "),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "input-box",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.port) = $event))
            }, null, 512), [
              [_vModelText, _ctx.port]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createTextVNode(" Enter the SSH user name and password of your robot. Then click or tap the Connect button. "),
          _createElementVNode("b", _hoisted_15, [
            _createTextVNode("User Name: "),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input-box",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.username) = $event)),
              spellcheck: "false"
            }, null, 512), [
              [_vModelText, _ctx.username]
            ])
          ]),
          _createElementVNode("b", _hoisted_16, [
            _createTextVNode("Password: "),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "input-box",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event)),
              spellcheck: "false"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createTextVNode(" Enter the domain ID of your robot below. "),
          _createElementVNode("b", _hoisted_20, [
            _createTextVNode("Domain Id: "),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input-box",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.domainId) = $event)),
              spellcheck: "false"
            }, null, 512), [
              [_vModelText, _ctx.domainId]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createTextVNode(" Input the path to the setup.bash or local_setup.bash file on your robot below, with each directory seperated by a / : "),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input-box",
              spellcheck: "false",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sourcePath) = $event))
            }, null, 512), [
              [_vModelText, _ctx.sourcePath]
            ])
          ]),
          _createElementVNode("p", _hoisted_22, [
            _createTextVNode(" What method would you like to use to load packages from the robot? "),
            _createVNode(_component_SearchableDropDown, {
              maxItem: 5,
              initiallySelected: {
              id: 0,
              name: 'Do not load any packages'
            },
              options: _ctx.loadPackagesModes,
              onSelected: _cache[7] || (_cache[7] = (pkgLoadMode) => (_ctx.selectedLoadMode = pkgLoadMode.id))
            }, null, 8, ["options"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", {
          class: "rectangle-button",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onConnect()))
        }, "Connect")
      ]),
      (
        _ctx.connectionStatus !== 'connected' && _ctx.connectionStatus !== 'disconnected'
      )
        ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.connectionStatus), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_LoadPackagesPopup, {
      visible: _ctx.isLoadingPackages,
      setVisible: _ctx.setPackageLoadingVisibility,
      loadMode: _ctx.selectedLoadMode
    }, null, 8, ["visible", "setVisible", "loadMode"])
  ], 64))
}